module.exports = __webpack_public_path__ + "static/img/qiepian33.e87a77a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/qiepian33.png
// module id = Ke/Q
// module chunks = 2